
<template>
<b-overlay
      :show="loading"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    >
  <div>
    <b-card title="Informations générales">
       <validation-observer ref="simpleRules">
        <b-form
          @submit.prevent
        >
        <b-row>
          <b-col
            md="6"
            xl="4"
            class="mb-1"
          >
            <b-form-group
              label="Titre"
              label-for="basicInput"
            >
             <validation-provider
              #default="{ errors }"
              name="Titre"
              rules="required"
            >
              <b-form-input
              required
                id="basicInput"
                v-model="form.title"
                :plaintext="readOnly"
                placeholder="Titre"
                :state="errors.length > 0 ? false:null"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
            </b-form-group>
          </b-col>

          <b-col
            md="6"
            xl="4"
            class="mb-1"
          >
            <b-form-group
              label="Photo"
              label-for="Photo"
            >
            
            <b-media vertical-align="top" v-if="file!==null">
                  <template #aside>
                    <b-img
                      :src="file"
                      blank-color="#ccc"
                      width="64"
                      alt="placeholder"
                      
                    />
                  </template>
                  
                  <b-card-text class="mb-0">
                
                    <b-button
                    size="sm"
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      variant="outline-warning"
                      class="btn-icon"
                      @click="editPhoto()"
                    >
                      <feather-icon icon="EditIcon" />
                    </b-button>
                  </b-card-text>
                </b-media>
            <b-form-file v-else
              
                v-model="file"
                :state="Boolean(file)"
                placeholder="Choisissez ou faites glisser un fichier..."
                drop-placeholder="Déposer ici ..."
                @change="fileAdded($event)"
            />
            </b-form-group>
          </b-col>

          <b-col
            md="6"
            xl="4"
            class="mb-1"
          >
          <b-form-group
              label="Note"
              label-for="Prix"
            >
             <validation-provider
              #default="{ errors }"
              name="Note"
              rules="required|between:0,5"
            >
            <b-form-input
              required
                id="Note"
                v-model="form.rate"
                :plaintext="readOnly"
                type="number"
                step="1"
                max="5"
                placeholder="Note"
                :state="errors.length > 0 ? false:null"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
            </b-form-group>
          </b-col>

          <b-col
            md="6"
            xl="4"
            class="mb-1"
          >
          <b-form-group
              label="Ajustement"
              label-for="Code"
            >
             <validation-provider
              #default="{ errors }"
              name="Ajustement"
              rules="required|between:0,5"
            >
              <b-form-input
              required
                id="Note"
                v-model="form.adjustment_rate"
                :plaintext="readOnly"
                type="number"
                step="1"
                max="5"
                :state="errors.length > 0 ? false:null"
                placeholder="Ajustement"
              />
               <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
            </b-form-group>
          </b-col>

          <b-col
            md="6"
            xl="4"
            class="mb-1"
          >
          <b-form-group
              label="Confort"
              label-for="Code"
            >
             <validation-provider
              #default="{ errors }"
              name="Confort"
              rules="required|between:0,5"
            >
              <b-form-input
              required
                id="Note"
                 :state="errors.length > 0 ? false:null"
                v-model="form.satisfaction_rate"
                :plaintext="readOnly"
                type="number"
                step="1"
                max="5"
                placeholder="Confort"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            md="6"
            xl="4"
            class="mb-1"
          >
          <b-form-group
              label="Commentaire"
              label-for="Code"
            >
             <validation-provider
              #default="{ errors }"
              name="Commentaire"
              rules="required"
            >
              <b-form-input
              required
                id="Code"
                v-model="form.comment"
                :plaintext="readOnly"
                :state="errors.length > 0 ? false:null"
                placeholder="Commentaire"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
            </b-form-group>
          </b-col>

          <b-col
            md="6"
            xl="4"
            class="mb-1"
          >
          <b-form-group
              label="Lunette"
              label-for="Texture"
            >
            <validation-provider
              #default="{ errors }"
              name="Lunette"
              rules="required"
            >
              <v-select
                v-model="form.glass"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                label="title"
                :state="errors.length > 0 ? false:null"
                :options="glassChoices"
              />

              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
      </validation-observer>

    </b-card>
  <b-button v-if="edition==false"
     @click="createRating"
    >
    Enregistrer
    </b-button>

    <b-button v-else
     @click="editRating"
    >
    Enregistrer
    </b-button>
  </div>
</b-overlay>
</template>

<script>
import { BButton,BFormInput, BForm,BOverlay, BRow, BCol, BFormGroup,BFormFile, BCard, BFormCheckbox, BFormTextarea,BCardText, BMedia, BImg} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import vSelect from 'vue-select'
import {APIRequest,Utils} from '@simb2s/senseye-sdk'
import Ripple from 'vue-ripple-directive'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, email } from '@validations'


export default {
  name: 'RatingForm',
  components: {
    BButton,
    BFormInput,
    BFormGroup,
    BCardText, 
    BMedia, 
    BImg,
    BRow,
    BCol,
    BFormFile,
    BOverlay,
    BCard,
    BFormCheckbox,
    BFormTextarea,
    vSelect,
    ValidationProvider,
    ValidationObserver,
    BForm
  },
  directives: {
    Ripple,
  },
  data() {
      return {
          currentBase64:null,
          file: null,
          loading:true,
          edition:false,
          glasses:[],
          glassChoices:[],
          form:{
            title:"",
            rate:0,
            comment:'',
            glass:'',
            adjustment_rate:0,
            satisfaction_rate:0,
            photo:'',
            custom:true
          },
      }
  },
  props: ['rating', 'readOnly'],
  methods:{
    editPhoto() {
      this.file=null
    },
    async getGlasses() {
      let glasses = await APIRequest.list('glasses')
      this.glasses=glasses[0];
      this.glassChoices=Utils.formatSelect(this.glasses,'name','id')
      
    },
    async createRating()
    {
       this.$refs.simpleRules.validate().then(async success => {
        if (success) {
        this.loading=true
        if(this.form.glass!=null)
        {
          let glass_id = this.form.glass.value
          this.form.glass={}
          this.form.glass.id=glass_id
        }
        try {
        
          await APIRequest.create('reviews',this.form)
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "L'avis client a bien été créé !",
              icon: 'CheckIcon',
              variant: 'success',
            },
          })
          this.$router.push({name:'ratings'})
        } catch (error) {
          this.loading=false
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Une erreur est survenue.',
              icon: 'AlertCircleIcon',
              variant: 'warning',
            },
          })
          
        }
        }
       })
      
    },
    async editRating()
    {
       this.$refs.simpleRules.validate().then(async success => {
        if (success) {
        this.loading=true
      if(this.form.glass!=null)
        {
          let glass_id = this.form.glass.value
          this.form.glass={}
          this.form.glass.id=glass_id
        }
        try {
        
          await APIRequest.update('reviews',this.rating.id,this.form)
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "L'avis client a bien été modifié !",
              icon: 'CheckIcon',
              variant: 'success',
            },
          })
          this.$router.push({name:'ratings'})
        } catch (error) {
          this.loading=false
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Une erreur est survenue.',
              icon: 'AlertCircleIcon',
              variant: 'warning',
            },
          })
          
        }
        }
       })
      
    },
    fileAdded(event)
    {
      var reader = new FileReader()
      reader.readAsDataURL(event.target.files[0])
      reader.onload = () => {
       
          let b64=reader.result.split(';')
          let type=b64[0]
          if(type.includes('image'))
          {
              let base64=b64[1]
              //base64.replace('base64,','')
              this.currentBase64=reader.result
              this.file=this.currentBase64
              this.form.photo=this.currentBase64
          }
          else
          {
              this.file=null
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Ceci n'est pas une image !",
                  icon: 'AlertCircleIcon',
                  variant: 'warning',
                },
              })
          }
          
      };
    },
     
      
  },
  async mounted(){
    await this.getGlasses()
    if(this.rating!=null)
    {
      this.form=this.rating
      this.file=this.rating.photo
      if(this.rating.glass!=null)
      {
        for(let i=0;i<this.glassChoices.length;i++)
        {
          if(this.rating.glass.id == this.glassChoices[i].value)
          {
            this.rating.glass = this.glassChoices[i]
          }
        }
      }
      this.edition=true
    }
    this.loading=false
  }

}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>